import axios from 'axios'
import { AUTH_URL, CREATE_NEW_PROFILE_URL } from '../../../vars'
import {errorHelper} from '../helper'

/**
 * @namespace Registration
 */
export default {
    state: {
        
    },
    mutations: {
        
    },
    actions: {
        /**
         * Регистрирует новго пользователя в системе
         * @param {Object} ctx 
         * @param {Object} data Данные регистрации
         * @returns {Object} Резьтат авторизации
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof Registration 
         */
       async REGISTRATION(ctx, data) {
            try {
                const res = await axios.post(`${AUTH_URL}register/`, data);
                return res
            } catch(e) {
                console.log(e)
                throw e
            }
       },
       
       async CREATE_NEW_PROFILE(ctx, data) {
            try {
                const res = await axios.post(CREATE_NEW_PROFILE_URL, data, {
                  headers: {
                    Authorization: `Token ${localStorage.token}`,
                  },
                });
                return res.data;
            } catch (e) {
                console.log('CREATE_NEW_PROFILE', e)
                throw e
            }    
        },
    },
    
    getters: {
        
    }
}